import { useState, useEffect } from 'react';

function useLoginActionMessage(action) {
    const [loginActionMessage, setLoginActionMessage] = useState(null);

    useEffect(() => {
        if (!action) return;
        setLoginActionMessage(null);
        switch (action) {
            case 'registered':
                setLoginActionMessage('Successfully registered to TCAP.');
                break;
            case 'activated':
                setLoginActionMessage(
                    'Successfully activated your TCAP account.',
                );
                break;
            case 'mfaTokenReset':
                setLoginActionMessage(
                    'Successfully removed your MFA token. Login to run the MFA setup again.',
                );
                break;
            case 'mfaEnabled':
                setLoginActionMessage(
                    'Successfully enabled MFA. Please re-login.',
                );
                break;
            case 'mfaDisabled':
                setLoginActionMessage(
                    'Successfully disabled MFA. Please re-login.',
                );
                break;
        }
    }, [action]);

    return { loginActionMessage };
}

export { useLoginActionMessage };
